<template>
    <el-card class="indigo-widget">
        <div v-if="$slots.header" slot="header">
            <slot name="header"></slot>
        </div>
        <div class="row mt-4 mb-2" v-if="hasResults">
            <closed-by-chart v-if="loaded" :data="datasets" :options="options" class="col-12 w-100"></closed-by-chart>
        </div>
        <div class="row col-12 my-2" v-else>
            <span class="text-muted small">No results available</span>
        </div>
    </el-card>
</template>


<script>
import ClosedByChart from "./charts/CloseByChart";

export default {
    components: {
        ClosedByChart
    },
    props: {
        token: {
            type: String,
            required: true
        },
        dateScope: {
            type: Object,
            required: true
        },
        teamId: {
            type: [Number, String],
            required: false
        },
        brokerId: {
            type: Number,
            required: false
        },
    },
    data() {
        return {
            closedReasons: [],
            datasets: [],
            loaded: false,
            options: {
                responsive: true,
                legend: {
                    display: true,
                    labels: {
                        fontFamily: "Poppins",
                        padding: 10,
                        boxWidth: 15,
                        fontSize: 12,
                        fontColor: "#000",
                        fontStyle: "normal"
                    },
                    position: "bottom"
                },
                tooltips: {
                    mode: "label",
                    titleFontFamily: "Poppins",
                    titleFontSize: 13,
                    titleMarginBottom: 15,
                    bodyFontFamily: "Poppins",
                    bodyFontSize: 13,
                    bodySpacing: 15,
                    cornerRadius: 0,
                    xPadding: 15,
                    yPadding: 15,
                    backgroundColor: 'rgba(8,7,48,0.8)',
                    callbacks: {
                        label: function (t, d) {
                            let label = d.labels[t.index];
                            let rawValue = d.datasets[0].data[t.index];
                            let value = Number(rawValue).toLocaleString("en-AU");
                            let total = d.datasets[0].data.reduce((sum, x) => sum + x);
                            let percentage = Number(rawValue / total * 100).toLocaleString("en-AU", {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 2
                            });
                            return " " + label + ": " + value + " (" + percentage + "%)";
                        }
                    }
                },
                maintainAspectRatio: false
            }
        };
    },
    mounted() {
        this.$bus.$on("refreshed-data", value => {
            this.refreshData();
        });
        this.refreshData();
    },
    watch: {
        dateScope: {
            handler(newVal, oldVal) {
                this.refreshData();
            },
            deep: true
        },
        teamId: {
            handler(newVal, oldVal) {
                this.refreshData();
            },
            deep: true
        },
        brokerId: {
            handler(newVal, oldVal) {
                this.refreshData();
            },
            deep: true
        }
    },
    computed: {

        hasResults() {

            const reducer = (accumulator, currentValue) => (parseInt(accumulator) || 0) + currentValue.count;

            return this.closedReasons.length ? this.closedReasons.reduce(reducer) : 0;

        }

    },
    methods: {
        refreshData() {
            this.getDailyClosedApps();
        },
        async getDailyClosedApps() {
            try {
                // this.loaded = false;
                let res = await axios.get(`/api/v2/closed/stats`, {
                    headers: {
                        Authorization: `Bearer ${this.token}`
                    },
                    params: {
                        startDate: this.$moment(this.dateScope.startDate).format('YYYY-MM-DD'),
                        endDate: this.$moment(this.dateScope.endDate).format('YYYY-MM-DD'),
                        teamId: this.teamId,
                        brokerId: this.brokerId
                    }
                });
                this.closedReasons = res.data;
                console.log('this.closedReasons', this.closedReasons)
                let labels = this.closedReasons.map(closedReason => {
                    return closedReason.reason;
                });
                let datasets = this.closedReasons.map(closedReason => {
                    return closedReason.count;
                });

                this.datasets = {
                    datasets: [
                        {
                            data: datasets,
                            backgroundColor: [
                                "#FF5722",
                                "#3F51B5",
                                "#009688",
                                "#2196F3",
                                "#673AB7",
                                "#FFC107",
                                "#4CAF50",
                                "#9E9E9E",
                                "#795548",
                                "#607D8B",
                                "#00BCD4",
                                "#E91E63"
                            ]
                        }
                    ],
                    labels: labels
                };
                this.loaded = true;
            } catch (err) {
                console.error(err);
            }
        }
    }
};
</script>
